import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const wrapper: ThemedFunctor = ({ theme }) => css`
  min-width: 15rem;
  padding: ${theme.remSize[150]};
`;
